import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { BuilderContextProvidersRegistry } from './builderContextProvidersRegistry'
import { BuilderFunctionLibraryRegistry } from './functionLibraryRegistry'
import { BuilderContextProvidersLoader } from './builderContextProvidersLoader'
import { BuilderContextProvidersPageWillMountHandler } from './builderContextProvidersPageWillMountHandler'
import {
	ContextProviderLoaderSymbol,
	ContextProviderRegistrySymbol,
	FunctionLibraryRegistrySymbol,
	BuilderModuleLoaderSymbol,
} from './symbols'
import { ClientBuilderModuleLoader } from './clientModuleLoader'
import { ImportMapProviderSymbol, LifeCycle, ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import {
	ContextProviderService,
	ContextBindingService,
	NoopContextBindingService,
	NoopContextProviderService,
} from './services'
import { ComponentWrapperSymbol } from '@wix/thunderbolt-components-loader'
import { ContextProviderWrapper } from './ContextProviderWrapper'
import { ContextBindingWrapper } from './ContextBindingWrapper'
import { BuilderContextProvidersImportMapProvider } from './importMapProvider'

export const bindCommonSite: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(NoopContextProviderService)
	bind(ServiceProviderSymbol).to(NoopContextBindingService)
	bind(ContextProviderRegistrySymbol).to(BuilderContextProvidersRegistry)
	bind(FunctionLibraryRegistrySymbol).to(BuilderFunctionLibraryRegistry)
	// ORDER MATTERS: last-bound wrapper is outermost.
	// ContextProviderWrapper must be OUTER so it mounts <ContextProvider> above
	// ContextBindingWrapper's useContext — otherwise the binding's useContext()
	// reads from no Provider and returns null.
	//
	// Example where this is load-bearing: a repeater both attaches a context
	// AND binds against it on the same compId, e.g.
	//   ds.contexts.attach(repeaterRef, 'foo.ctx', null)
	//   ds.bindings.bind(repeaterRef, 'foo.ctx', { items: { itemPath: 'animals' } })
	// Render tree must be:
	//   <ContextProviderWrapper>      mounts <Ctx.Provider value={...}>
	//     <ContextBindingWrapper>     useContext(Ctx) → reads value from above
	//       <Repeater />
	// If the order is inverted, the binding's useContext fires before the
	// Provider mounts in the tree and resolves to the context's default value.
	bind(ComponentWrapperSymbol).to(ContextBindingWrapper)
	bind(ComponentWrapperSymbol).to(ContextProviderWrapper)
	bind(ImportMapProviderSymbol).to(BuilderContextProvidersImportMapProvider)
}

export const site: ContainerModuleLoader = (bind) => {
	bindCommonSite(bind)
	bind(BuilderModuleLoaderSymbol).to(ClientBuilderModuleLoader)
	bind(ContextProviderLoaderSymbol).to(BuilderContextProvidersLoader)
}

export const page: ContainerModuleLoader = (bind) => {
	bind(LifeCycle.PageWillMountHandler).to(BuilderContextProvidersPageWillMountHandler)
	bind(ServiceProviderSymbol).to(ContextProviderService)
	bind(ServiceProviderSymbol).to(ContextBindingService)
}
